import React, {Component} from 'react';
import {subscribe} from "../Actions";
import {Dimmer, Image, Loader, Message, Modal, Segment} from "semantic-ui-react";
import {Redirect} from "react-router-dom";

export default class Subscribe extends Component {
    componentDidMount() {
        setTimeout(() => {
            subscribe(this.props.token)
        }, 10)
    }

    render() {
        if (this.props.showSpinner) {
            return <Segment>
                <Dimmer active>
                    <Loader content={this.props.modalMessage}/>
                </Dimmer>

                <Image src='/assets/images/wireframe/short-paragraph.png'/>
            </Segment>
        } else {
            if (this.props.success) {
                setTimeout(function(){
                    window.location.reload();
                });
                return <Redirect to="/getting-started"/>
            } else {
                return <Modal
                    size='small'
                    open={true}>
                    <Modal.Content>
                        <Message error={!this.props.success}
                                 success={this.props.success}
                                 content={this.props.modalMessage}/>
                    </Modal.Content>
                </Modal>
            }
        }
    }
}


/** WEBPACK FOOTER **
 ** ./src/shared_states/SubscriptionRequest/components/Subscribe.js
 **/